import { all, takeEvery, put, call } from 'redux-saga/effects'
import { withCallback } from 'redux-saga-callback'
import { history, store as reduxStore } from 'index'
import { push } from 'react-router-redux'
import { notification } from 'antd'
import {
  login,
  loginOTP,
  signup,
  currentAccount,
  getAccountFromToken,
  updateProfile,
  sendResetPasswordEmail,
  resetPassword,
  oAuthGoogle,
  getBillingData,
  acceptCollboratorInvitation,
  manualOutreach,
  registerEmail,
  getCustomerContext,
} from 'services/user'
import _ from 'lodash'
import urlencode from 'urlencode'
import Cookies from 'js-cookie'
import customLanguageTexts from '../../language'
import {
  isAuthErrorCode,
  handleErrors,
  definedErrorCodes,
  checkIfFreeEmailDomain,
} from '../../helpers'
import actions from './actions'
import constants from '../../constants'

export function* LOGIN({ payload }) {
  const { email, password } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(login, _.toLower(email), password)
  if (success && success.data && success.data.id && success.data.id) {
    localStorage.removeItem('ccPreviewBuilderId')

    localStorage.removeItem('ccBuilderConfig')
    // check if we have previouslyy visited app ID
    let redirectToApps = false
    if (localStorage.getItem('cc_lastOpenedApp')) {
      yield put({
        type: 'user/SET_STATE',
        payload: {
          openLastVisitedApp: true,
        },
      })
    } else redirectToApps = true

    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
      data: success.data,
    })
    if (redirectToApps) {
      yield history.push('/apps')
    }
  } else if (success && success.data && success.data.success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
        loginEmail: _.toLower(email),
        loginPassword: password,
      },
    })
    yield history.push('/verify-account')
  } else {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (
      success.error !== undefined &&
      success.errcode !== undefined &&
      definedErrorCodes(success.errcode)
    ) {
      const errorMsgs = handleErrors(success.errcode, 'login')
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'info',
          message: errorMsgs.description,
        },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: success.errDescription
            ? success.errDescription
            : 'Login failed. Please try again.',
        },
      })
    }
  }
  return success
}

export function* LOGIN_OTP({ payload }) {
  const { otp } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { loginEmail, loginPassword } = reduxStore.getState().user

  const success = yield call(loginOTP, loginEmail, loginPassword, otp)
  if (success && success.data) {
    localStorage.removeItem('ccPreviewBuilderId')
    // check if we have previously visited app ID
    let redirectToApps = false
    if (localStorage.getItem('cc_lastOpenedApp')) {
      yield put({
        type: 'user/SET_STATE',
        payload: {
          openLastVisitedApp: true,
        },
      })
    } else redirectToApps = true

    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
      data: success.data,
    })
    if (redirectToApps) {
      yield history.push('/apps')
    }
  } else {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (
      success.error !== undefined &&
      success.errcode !== undefined &&
      definedErrorCodes(success.errcode)
    ) {
      const errorMsgs = handleErrors(success.errcode, 'login')
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'info',
          message: errorMsgs.description,
        },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: success.errDescription
            ? success.errDescription
            : 'Login failed. Please try again.',
        },
      })
    }
  }
  return success
}

export function* LOGIN_TOKEN({ payload }) {
  const { token, new: newUser } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const success = yield call(getAccountFromToken, token)
  if (success && success.data) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
      data: success.data,
    })

    if (newUser) {
      yield history.push('/choose-role')
    } else {
      yield history.push('/')
    }
  } else {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })

    yield history.push('/login')
  }
}

export function* SIGN_UP({ payload }) {
  const params = reduxStore.getState().router.location.pathname.split('/verify/email/')[1]
  const verificationCode = params.split('/')[0]
  const email = atob?.(params.split('/')[1])

  const { name, password, role, otherRole, contactNumber, countryCode, invitedApp } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const formValues = {
    verificationCode,
    name: name.trim(),
    email: email.trim(),
    password,
    contactNumber,
    meta: {
      role,
      otherRole: role === 'other' ? otherRole : '',
      countryCode,
      disableMFA: true,
    },
  }
  if (invitedApp) {
    formValues.appId = invitedApp
  }
  const success = yield call(signup, formValues)

  if (success && success.data) {
    success.data.firstLogin = true
    success.data.meta = { role }

    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
      data: success.data,
    })

    yield history.push('/choose-role')
  } else if (success && success.error) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'info', message: success.errDescription },
    })
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield history.push('/signup')
  } else {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
        showModal: true,
      },
    })
  }

  return success
}

export function* LOAD_CURRENT_ACCOUNT(data = []) {
  let loginId = 0
  let showOnboarding = false
  let redirect = false
  const nonAppPagePaths = [
    '/login',
    '/verify-account',
    '/signup',
    '/register',
    '/forgot-password',
    '/token/:id',
    '/verification-email-sent',
    '/reset-password-email-sent',
    '/sso-complete',
  ]
  if (data.data !== undefined) {
    data.authorized = true
    loginId = data.data.id
    if (data.firstLogin !== undefined && data.firstLogin) showOnboarding = true
  } else if (localStorage.getItem('ccBearerToken')) {
    const checkIfAppPath = _.indexOf(
      nonAppPagePaths,
      reduxStore.getState().menu.globalRouteMatch.path,
    )
    if (checkIfAppPath >= 0) {
      redirect = true
    } else if (
      reduxStore.getState().menu.globalRouteMatch.path !== undefined &&
      reduxStore.getState().menu.globalRouteMatch.path.indexOf('/reset/password') >= 0
    ) {
      redirect = true
    } else if (
      reduxStore.getState().router.location.pathname !== undefined &&
      reduxStore.getState().router.location.pathname.indexOf('/verify/email') >= 0
    ) {
      redirect = true
    }

    const loginData = { data: localStorage.getItem('meInfo') }
    loginId = loginData.data.id
  }
  if (localStorage.getItem('ccBearerToken')) {
    if (
      data.data !== undefined &&
      reduxStore.getState().router &&
      reduxStore.getState().router.location !== undefined &&
      (reduxStore.getState().router.location.pathname === '/signup' ||
        reduxStore.getState().router.location.pathname === '/register') &&
      (Cookies.get('_ga') || Cookies.get('utm') || Cookies.get('hubspotutk'))
    ) {
      let userGaId = ''
      if (Cookies.get('_ga')) {
        userGaId = Cookies.get('_ga')
      }
      let userUtm = {}
      if (Cookies.get('utm')) {
        userUtm = JSON.parse(Cookies.get('utm'))
      }
      let userUtmLast = {}
      if (Cookies.get('utm_last')) {
        userUtmLast = JSON.parse(Cookies.get('utm_last'))
      }
      let userHubsSpotId = ''
      if (Cookies.get('hubspotutk')) {
        userHubsSpotId = Cookies.get('hubspotutk')
      }
      const gaValuesForUsermeta = {
        meta: {
          ...data.data.meta,
          ...{
            ga_id: userGaId,
            utm: userUtm,
            utm_last: userUtmLast,
            hubspotId: userHubsSpotId,
          },
        },
      }
      yield call(updateProfile, gaValuesForUsermeta)
    }
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: true,
      },
    })

    const response = yield call(currentAccount, loginId)
    if (response && response.data) {
      response.data.authorized = true
      response.data.loading = false
      response.data.showOnboarding = showOnboarding
      yield put({
        type: 'user/SET_STATE',
        payload: response.data,
      })

      const { openLastVisitedApp } = reduxStore.getState().user

      if (openLastVisitedApp) {
        const lastOpenedAppId = localStorage.getItem('cc_lastOpenedApp')
        const ccPreviewBuilderId = localStorage.getItem('ccPreviewBuilderId')
        yield put({
          type: 'user/SET_STATE',
          payload: {
            openLastVisitedApp: false,
          },
        })

        if (ccPreviewBuilderId) {
          yield history.push(`/app/${lastOpenedAppId}/messaging-get-started`)
        } else {
          yield history.push(`/app/${lastOpenedAppId}/overview`)
        }
      } else if (redirect) yield history.push('/apps')
      yield put({
        type: 'user/SET_STATE',
        loading: false,
      })
    } else {
      yield put({
        type: 'user/SET_STATE',
        payload: {
          loading: false,
        },
      })

      yield put({
        type: 'user/LOGOUT',
      })

      if (response && response.error) {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'info', message: response.errDescription },
        })
      }

      if (redirect) yield history.push('/login')
    }
  } else {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
    const checkIfAppPath = _.indexOf(
      nonAppPagePaths,
      reduxStore.getState().menu.globalRouteMatch.path,
    )
    let checkIfResetPassword = false

    let checkIfCollaboratorInvitation = false
    if (reduxStore.getState().menu.globalRouteMatch.path !== undefined) {
      checkIfResetPassword = reduxStore
        .getState()
        .menu.globalRouteMatch.path.indexOf('/reset/password')

      checkIfCollaboratorInvitation = reduxStore
        .getState()
        .menu.globalRouteMatch.path.indexOf('/invite/collaborator')
    }

    if (checkIfAppPath < 0) {
      if (checkIfResetPassword >= 0 || checkIfCollaboratorInvitation >= 0) {
        if (reduxStore.getState().router.location.pathname.indexOf('/token/') >= 0) {
          const token = reduxStore
            .getState()
            .router.location.pathname.substring(
              reduxStore.getState().router.location.pathname.lastIndexOf('/') + 1,
            )
          yield put({
            type: 'user/LOGIN_TOKEN',
            payload: { token },
          })
        }

        yield history.push(reduxStore.getState().router.location.pathname)
      } else yield history.push(reduxStore.getState().menu.globalRouteMatch.path)
    } else if (checkIfResetPassword >= 0 || checkIfCollaboratorInvitation >= 0) {
      yield history.push(reduxStore.getState().menu.globalRouteMatch.url)
    } else {
      if (
        reduxStore.getState().router &&
        reduxStore.getState().router.location !== undefined &&
        (reduxStore.getState().router.location.pathname === '/login' ||
          reduxStore.getState().router.location.pathname === '/verify-account' ||
          reduxStore.getState().router.location.pathname === '/signup' ||
          reduxStore.getState().router.location.pathname === '/register') &&
        reduxStore.getState().router.location.query !== undefined &&
        (reduxStore.getState().router.location.query.utm_source !== undefined ||
          reduxStore.getState().router.location.query.utm_medium !== undefined ||
          reduxStore.getState().router.location.query.utm_campaign !== undefined ||
          reduxStore.getState().router.location.query.utm_term !== undefined ||
          reduxStore.getState().router.location.query.utm_content !== undefined)
      ) {
        if (
          reduxStore.getState().router.location.pathname !== '/login' &&
          reduxStore.getState().router.location.pathname !== '/verify-account'
        ) {
          let utmCookieObject = {}
          // let cookieUtmSource = ''
          // let cookieUtmMedium = ''
          // let cookieUtmCampaign = ''
          // let cookieUtmTerm = ''
          // let cookieUtmContent = ''
          // if (Cookies.get('utm')) {
          //   const utmParam = JSON.parse(Cookies.get('utm'))
          //   if (utmParam.length) {
          //     if (utmParam.source !== undefined) cookieUtmSource = utmParam.source
          //     if (utmParam.medium !== undefined) cookieUtmMedium = utmParam.medium
          //     if (utmParam.campaign !== undefined) cookieUtmCampaign = utmParam.campaign
          //     if (utmParam.term !== undefined) cookieUtmTerm = utmParam.term
          //     if (utmParam.content !== undefined) cookieUtmContent = utmParam.content
          //   }
          // }
          // if (Cookies.get('utm_last')) {
          //   const utmLastParam = JSON.parse(Cookies.get('utm_last'))
          //   if (utmLastParam.length) {
          //     if (utmLastParam.source !== undefined) cookieUtmSource = utmLastParam.source
          //     if (utmLastParam.medium !== undefined) cookieUtmMedium = utmLastParam.medium
          //     if (utmLastParam.campaign !== undefined) cookieUtmCampaign = utmLastParam.campaign
          //     if (utmLastParam.term !== undefined) cookieUtmTerm = utmLastParam.term
          //     if (utmLastParam.content !== undefined) cookieUtmContent = utmLastParam.content
          //   }
          // }

          utmCookieObject = {
            source:
              reduxStore.getState().router.location.query.utm_source !== undefined &&
              reduxStore.getState().router.location.query.utm_source.trim() !== ''
                ? reduxStore.getState().router.location.query.utm_source
                : '',
            medium:
              reduxStore.getState().router.location.query.utm_medium !== undefined &&
              reduxStore.getState().router.location.query.utm_medium.trim() !== ''
                ? reduxStore.getState().router.location.query.utm_medium
                : '',
            campaign:
              reduxStore.getState().router.location.query.utm_campaign !== undefined &&
              reduxStore.getState().router.location.query.utm_campaign.trim() !== ''
                ? reduxStore.getState().router.location.query.utm_campaign
                : '',
            term:
              reduxStore.getState().router.location.query.utm_term !== undefined &&
              reduxStore.getState().router.location.query.utm_term.trim() !== ''
                ? reduxStore.getState().router.location.query.utm_term
                : '',
            content:
              reduxStore.getState().router.location.query.utm_content !== undefined &&
              reduxStore.getState().router.location.query.utm_content.trim() !== ''
                ? reduxStore.getState().router.location.query.utm_content
                : '',
          }
          utmCookieObject = JSON.stringify(utmCookieObject)

          if (Cookies.get('utm')) {
            if (Cookies.get('utm_last')) {
              Cookies.remove('utm_last', { path: '', domain: `.${constants.domainToSetCookies}` })
              Cookies.remove('utm_last', {
                path: '',
                domain: `app.${constants.domainToSetCookies}`,
              })
            }
            Cookies.set('utm_last', utmCookieObject, {
              expires: 365,
              domain: `.${constants.domainToSetCookies}`,
            })
          } else {
            Cookies.set('utm', utmCookieObject, {
              expires: 365,
              domain: `.${constants.domainToSetCookies}`,
            })
          }
        }
      }
      if (
        reduxStore.getState().router &&
        reduxStore.getState().router.location !== undefined &&
        (reduxStore.getState().router.location.pathname === '/login' ||
          reduxStore.getState().router.location.pathname === '/verify-account' ||
          reduxStore.getState().router.location.pathname === '/signup' ||
          reduxStore.getState().router.location.pathname === '/sso-complete' ||
          reduxStore.getState().router.location.pathname === '/register' ||
          reduxStore.getState().router.location.pathname === '/forgot-password' ||
          reduxStore.getState().router.location.pathname === '/reset-password-email-sent' ||
          reduxStore.getState().router.location.pathname === ' /verify/email/:id/:email' ||
          reduxStore.getState().router.location.pathname === '/verification-email-sent')
      ) {
        if (
          reduxStore.getState().router &&
          reduxStore.getState().router.location !== undefined &&
          (reduxStore.getState().router.location.pathname === '/signup' ||
            reduxStore.getState().router.location.pathname === '/register') &&
          Cookies.get('_ga')
        ) {
          Cookies.remove('ga_id', { path: '', domain: `.${constants.domainToSetCookies}` })
          Cookies.set('ga_id', Cookies.get('_ga'), {
            expires: 365,
            domain: `.${constants.domainToSetCookies}`,
          })
        }

        if (
          reduxStore.getState().router &&
          reduxStore.getState().router.location !== undefined &&
          (reduxStore.getState().router.location.pathname === '/signup' ||
            reduxStore.getState().router.location.pathname === '/register') &&
          reduxStore.getState().router.location.query !== undefined &&
          reduxStore.getState().router.location.query.email !== undefined &&
          _.trim(reduxStore.getState().router.location.query.email).length > 0
        ) {
          yield put({
            type: 'user/SET_STATE',
            payload: {
              prefilledSignupEmail: _.trim(
                urlencode.decode(reduxStore.getState().router.location.query.email),
              ),
              prefilledSignupEmailDisabled: false,
            },
          })
        }

        yield history.push(reduxStore.getState().router.location.pathname)
      } else yield history.push('/login')
    }
  }
}

/*  UPDATE_USER_PROFILE */

export function* UPDATE_USER_PROFILE({ payload }) {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  let oldEmail = reduxStore.getState().user.email
  oldEmail = _.trim(_.toLower(oldEmail))
  const formEmail = _.trim(_.toLower(payload.email))
  let emailUpdate = false
  let passwordUpdate = false
  if (oldEmail !== formEmail) {
    emailUpdate = true
  }
  const currentUserMeta = reduxStore.getState().user.meta
  let formValues
  if (_.trim(payload.contactNumber) === '' || _.trim(payload.contactNumber) === '+') {
    if (_.trim(payload.password) === '') {
      formValues = {
        name: payload.name,
        email: payload.email,
        meta: _.merge(currentUserMeta, {
          country: payload.country,
          countryCode: '',
          role: payload.role,
          otherRole: payload.role === 'other' ? payload.otherRole : '',
        }),
        unset: ['contactNumber'],
      }
      if (!emailUpdate) {
        formValues = {
          name: payload.name,
          meta: _.merge(currentUserMeta, {
            country: payload.country,
            countryCode: '',
            role: payload.role,
            otherRole: payload.role === 'other' ? payload.otherRole : '',
          }),
          unset: ['contactNumber'],
        }
      }
    } else {
      formValues = {
        name: payload.name,
        email: payload.email,
        password: payload.password,
        meta: _.merge(currentUserMeta, {
          country: payload.country,
          countryCode: '',
          role: payload.role,
          otherRole: payload.role === 'other' ? payload.otherRole : '',
        }),
        unset: ['contactNumber'],
      }
      if (!emailUpdate) {
        formValues = {
          name: payload.name,
          password: payload.password,
          meta: _.merge(currentUserMeta, {
            country: payload.country,
            countryCode: '',
            role: payload.role,
            otherRole: payload.role === 'other' ? payload.otherRole : '',
          }),
          unset: ['contactNumber'],
        }
      }
      passwordUpdate = true
    }
  } else {
    formValues = {
      name: payload.name,
      email: payload.email,
      password: payload.password,
      meta: _.merge(currentUserMeta, {
        country: payload.country,
        countryCode: payload.countryCode,
        role: payload.role,
        otherRole: payload.role === 'other' ? payload.otherRole : '',
      }),
      contactNumber: payload.contactNumber,
    }
    if (!emailUpdate) {
      formValues = {
        name: payload.name,
        password: payload.password,
        meta: _.merge(currentUserMeta, {
          country: payload.country,
          countryCode: payload.countryCode,
          role: payload.role,
          otherRole: payload.role === 'other' ? payload.otherRole : '',
        }),
        contactNumber: payload.contactNumber,
      }
    }
    passwordUpdate = true
    if (_.trim(payload.password) === '') {
      formValues = {
        name: payload.name,
        email: payload.email,
        meta: _.merge(currentUserMeta, {
          country: payload.country,
          countryCode: payload.countryCode,
          role: payload.role,
          otherRole: payload.role === 'other' ? payload.otherRole : '',
        }),
        contactNumber: payload.contactNumber,
      }
      if (!emailUpdate) {
        formValues = {
          name: payload.name,
          meta: _.merge(currentUserMeta, {
            country: payload.country,
            countryCode: payload.countryCode,
            role: payload.role,
            otherRole: payload.role === 'other' ? payload.otherRole : '',
          }),
          contactNumber: payload.contactNumber,
        }
      }
      passwordUpdate = false
    }
  }
  const success = yield call(updateProfile, formValues)
  if (success && success.data !== undefined) {
    success.data.emailUpdate = emailUpdate
    success.data.passwordUpdate = passwordUpdate
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
      data: success.data,
    })

    // Redirection logic after role update (step 2)
    if (payload.redirectAfterOnBoardingRoleUpdate) {
      const invitedApp = reduxStore.getState().user.invitedAppID
      if (invitedApp && _.trim(invitedApp) !== '') {
        if (checkIfFreeEmailDomain(success.data.email)) {
          yield put(push(`/apps`))
        } else {
          yield put({
            type: 'user/UPDATE_CUSTOMER_ON_DISPLAYING_KICKOFF_CALL_SCREEN',
          })
          yield put({
            type: 'apps/SET_STATE',
            payload: {
              firstAppID: invitedApp,
            },
          })
          yield put(push('/schedule-your-kick-off-call'))
        }
      } else {
        yield history.push('/create-your-first-application')
      }
    }
  } else {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: success.description },
    })
    if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      yield history.push('/login')
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.errDescription },
      })
    }
  }
  return success
}

/*  BETA_CUSTOMER_UPDATE */

export function* BETA_CUSTOMER_UPDATE({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  let formValues
  const currentUserMeta = reduxStore.getState().user.meta
  if (payload.userBeta === true) {
    formValues = {
      meta: _.merge(currentUserMeta, {
        betaCustomer: payload.userBeta,
      }),
    }
  }
  if (payload.userBeta === false) {
    formValues = {
      meta: _.merge(currentUserMeta, {
        betaCustomer: false,
      }),
    }
  }
  const success = yield call(updateProfile, formValues)
  if (success && success.data !== undefined) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
      data: success.data,
    })

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }

  return success
}

/*  UPDATE_2FA_ACCOUNT_STATUS */

export function* UPDATE_2FA_ACCOUNT_STATUS({ payload }) {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const currentUserMeta = reduxStore.getState().user.meta
  let updatedStatus = 'enabled'

  const formValues = {
    meta: _.merge(currentUserMeta, {
      disableMFA: payload.disableMFA,
    }),
  }
  if (payload.disableMFA) {
    updatedStatus = 'disabled'
  }

  const success = yield call(updateProfile, formValues)
  if (success && success.data !== undefined) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
      data: success.data,
    })
    if (!payload.hideNotification) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'success',
          message: `Two factor authentication ${updatedStatus} for your account.`,
        },
      })
    }

    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }

  return success
}

/* SHOW_USER_FEEBACK */

export function* SHOW_USER_FEEBACK({ payload }) {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (payload.showFeedback) {
    // not a beta customer
    yield put({
      type: 'settings/SET_STATE',
      payload: {
        visibleModalID: 'showFeedBackModal',
      },
    })
  }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

/*  CUSTOMER_SWITCHED_DASHBOARD */

export function* CUSTOMER_SWITCHED_DASHBOARD({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  let formValues
  const currentUserMeta = reduxStore.getState().user.meta

  if (payload.switchToOld) {
    // the toggle on the new dashboard
    formValues = {
      meta: _.merge(currentUserMeta, {
        customerSwitchedToOldDashboard: payload.dateNow,
      }),
    }
  } else if (!payload.switchToOld) {
    // the toggle on the old dashboard
    formValues = {
      meta: _.merge(currentUserMeta, {
        customerSwitchedToNewDashboard: payload.dateNow,
      }),
    }
  }

  const success = yield call(updateProfile, formValues)
  if (success && success.data !== undefined) {
    if (!_.isEmpty(currentUserMeta) && currentUserMeta !== undefined) {
      const intent = _.join(
        [constants.ManualOutreachIntents['customer-switched-to-old-dashboard'], payload.source],
        ' / ',
      )
      const post = { intent }
      const successManualOutreach = yield call(manualOutreach, post)
      if (successManualOutreach && successManualOutreach.data) {
        yield put({
          type: 'apps/SET_STATE',
          payload: {
            loading: false,
          },
        })
      } else {
        yield put({
          type: 'apps/SET_STATE',
          payload: {
            loading: false,
          },
        })
      }
    }
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
      data: success.data,
    })

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
  return success
}

/*  UPDATE_ONBOARDING STEP2 */

export function* ONBOARDING_STEP2({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const currentUserMeta = reduxStore.getState().user.meta
  const formValues = {
    meta: _.merge(currentUserMeta, {
      account: payload.account,
      role: payload.role,
      other_role: payload.role === 'other' ? payload.other_role : '',
      isMetaPresent: true,
      position: payload.position,
      goal: payload.goal,
    }),
  }
  const success = yield call(updateProfile, formValues)
  if (success && success.data !== undefined) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
      data: success.data,
    })

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }

  return success
}

export function* REQUEST_RESET_PASSWORD_EMAIL({ payload }) {
  const { email, message } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(sendResetPasswordEmail, email)

  if (success && success.data) {
    yield history.push(
      `reset-password-email-sent?email=${encodeURIComponent(_.toLower(email).trim())}`,
    )
    if (message) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message },
      })
    }
  } else if (success && success.error) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'info', message: success.errDescription },
    })
  }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* RESET_PASSWORD({ payload }) {
  const { password } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (
    reduxStore.getState().router &&
    reduxStore.getState().router.location !== undefined &&
    reduxStore.getState().router.location.pathname.includes('/reset/password/') &&
    reduxStore.getState().router.location.pathname.split('/reset/password/').length >= 2
  ) {
    const resetPasswordToken = reduxStore
      .getState()
      .router.location.pathname.split('/reset/password/')[1]
    const success = yield call(resetPassword, password, resetPasswordToken)
    if (success && success.data) {
      yield history.push('/login')

      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'success',
          message: 'Password successfully reset. You can now login with your new password.',
        },
      })
    } else if (success && success.error && success.error) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: success.errDescription,
        },
      })
      yield history.push('/login')
    }
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* GET_BILLING_DATA() {
  let response = []

  if (localStorage.getItem('ccBearerToken')) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: true,
      },
    })

    response = yield call(getBillingData)
    if (
      response.error !== undefined &&
      response.error.code !== undefined &&
      isAuthErrorCode(response.error.code)
    ) {
      yield put({
        type: 'user/LOGOUT',
      })
    }
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })

    yield history.push('/login')
  }
  return response
}

export function* TEAM_COLLABORATOR_ACCEPT_INVITE() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  let success = false
  success = true
  if (
    reduxStore.getState().router &&
    reduxStore.getState().router.location !== undefined &&
    reduxStore.getState().router.location.pathname.includes('/invite/collaborator/') &&
    reduxStore.getState().router.location.pathname.split('/invite/collaborator/').length >= 2
  ) {
    const collboratorInvitationToken = reduxStore
      .getState()
      .router.location.pathname.split('/invite/collaborator/')[1]
    success = yield call(acceptCollboratorInvitation, collboratorInvitationToken)
    if (success && success.data.success) {
      if (localStorage.getItem('ccBearerToken')) {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: {
            type: 'success',
            message: 'You have successfully accepted invitation for app collaboration.',
          },
        })

        yield put({
          type: 'apps/LIST',
          payload: { currentPage: 1 },
        })
        yield history.push('/apps')
      } else if (success.data.user !== undefined && success.data.user.pendingRegistration) {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: {
            type: 'success',
            message: customLanguageTexts.TEAM_INVITATION_ACCEPTED_SIGNUP_MESSAGE,
          },
        })
        if (success.data.user !== undefined && success.data.user.email !== undefined) {
          yield put({
            type: 'user/SET_STATE',
            payload: {
              prefilledSignupEmail: success.data.user.email,
              prefilledSignupEmailDisabled: true,
            },
          })
        }
        yield history.push('/signup')
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: {
            type: 'success',
            message: customLanguageTexts.TEAM_INVITATION_ACCEPTED_LOGIN_MESSAGE,
          },
        })

        if (success.data.user !== undefined && success.data.user.email !== undefined) {
          yield put({
            type: 'user/SET_STATE',
            payload: {
              prefilledLoginEmail: success.data.user.email,
            },
          })
        }
        yield history.push('/login')
      }
    }
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
  return success
}

export function* LOGOUT() {
  yield history.push('/login')

  yield put({
    type: 'user/SET_STATE',
    payload: {
      id: '',
      name: '',
      role: '',
      email: '',
      avatar: '',
      card: false,
      meta: {},
      authorized: false,
      emailVerified: false,
      loading: false,
      prefilledLoginEmail: '',
      prefilledSignupEmail: '',
      prefilledSignupEmailDisabled: false,
      actionLogout: false,
      signupEmail: '',
      betaCustomer: false,
      openLastVisitedApp: false,
      customerContext: {},
      loginEmail: '',
      loginPassword: '',
    },
  })
  yield put({
    type: 'settings/SET_STATE',
    payload: {
      visibleModalID: '',
    },
  })
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      data: [],
      meta: [],
      active: [],
      appSettings: [],
      apikeysList: [],
      apikeysAuthList: [],
      apikeysRestList: [],
      apikeysActive: [],
      apikeySearchText: '',
      apikeyQuickStart: 'API_KEY',
      usersList: [],
      usersActive: [],
      usersActiveList: [],
      usersInactiveList: [],
      userSearchText: '',
      userInactiveSearchText: '',
      rolesList: [],
      rolesActive: [],
      roleSearchText: '',
      groupsList: [],
      groupsActive: [],
      groupSearchText: '',
      groupMemberSearchText: '',
      groupBannedMemberSearchText: '',
      groupUserSearchText: '',
      userNonGroupsList: [],
      groupMembersList: [],
      groupBannedMembersList: [],
      botsList: [],
      botsActive: [],
      extensionsAllList: [],
      extensionsInstalledList: [],
      extensionsActive: [],
      sentManualIntentExtensionIds: [],
      extensionsTypeActive: 'all',
      extensionSearchText: '',
      webhooksList: [],
      triggersList: [],
      webhooksActive: [],
      uAuthTokensList: [],
      uAuthTokenSearchText: '',
      uFriendsList: [],
      uGroupsList: [],
      uFriendsListTotal: 0,
      uGroupsListTotal: 0,
      friendUserSearchText: '',
      userNonFriendsList: [],
      subscribePlanOngoingData: [],
      subscribePlanOngoingLink: '',
      subscribePlanAppData: [],
      subscribeTotalCharge: 0,
      usersListTotal: 0,
      usersListActiveTotal: 0,
      usersListInactiveTotal: 0,
      apikeysListTotal: 0,
      apikeysListAuthTotal: 0,
      apikeysListRestTotal: 0,
      rolesListTotal: 0,
      groupsListTotal: 0,
      webhooksListTotal: 0,
      botsListTotal: 0,
      groupMembersListTotal: 0,
      groupBannedMembersListTotal: 0,
      stats: [],
      messageLogs: [],
      messageLogsLoadMoreId: 0,
      messageLogsPollingId: 0,
      messageLogsLoading: false,
      messageSearchLogs: [],
      messageSearchLogsLoading: false,
      messageSearchExceedsLimit: false,
      chatWidgetsList: [],
      chatWidgetsCombinedList: [],
      chatWidgetAppUrl: false,
      chatWidgetActive: [],
      modMessageLogs: [],
      modMessageLogsLoadMoreId: 0,
      modMessageLogsLoading: false,
      groupsModerationList: [],
      groupsModerationListTotal: 0,
      groupsModerationActive: [],
      groupModerationSearchText: '',
      groupMessageLogs: [],
      groupMessageLogsLoading: false,
      teamCollaboratorsList: [],
      teamCollaboratorsListTotal: 0,
      teamCollaboratorsActive: [],
      teamLoggedInCollaborator: [],
      teamCollaboratorSearchText: '',
      appsListTotal: 0,
      appSearchText: '',
      appsListPageNo: 1,
      metricsDau: [],
      metricsHau: [],
      metricsCcu: [],
      metricsMau: [],
      metricsAUCMinute: 0,
      metricsAUCHour: 0,
      metricsAUCDay: 0,
      metricsAUCMonth: 0,
      metricsPlatform: [],
      metricsPlanSupport: false,
      metricsLoading: false,
      loading: false,
      nonFriendList: [],
      nonFriendListTotal: 0,
      nonGroupList: [],
      nonGroupListTotal: 0,
    },
  })
  localStorage.removeItem('ccBearerToken')
  localStorage.removeItem('meInfo')
  localStorage.removeItem('userData')
  const lastOpenedAppId = localStorage.getItem('cc_lastOpenedApp')
  const ccPreviewBuilderId = localStorage.getItem('ccPreviewBuilderId')

  localStorage.clear()
  if (lastOpenedAppId) localStorage.setItem('cc_lastOpenedApp', lastOpenedAppId)
  if (ccPreviewBuilderId) localStorage.setItem('ccPreviewBuilderId', ccPreviewBuilderId)
  // yield history.push('/login')
}

export function* GOOGLE_LOGIN({ payload }) {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { token, googleId } = payload

  const res = yield call(oAuthGoogle, token, googleId)

  if (res.success && res.data) {
    yield put({
      type: 'user/SIGN_UP',
      payload: res.data,
    })
  } else {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })

    notification.error({
      message: 'Invalid credentials',
      description: 'Unable to login',
    })
  }
}

export function* CHECK_CARD_STATUS_ACTION({ payload = {} }) {
  let response = []
  const { source } = payload
  if (localStorage.getItem('ccBearerToken')) {
    if (source === undefined) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: true,
        },
      })
    }

    const loginData = { data: localStorage.getItem('meInfo') }
    const loginId = loginData.data.id
    const userResponse = yield call(currentAccount, loginId)
    if (userResponse && userResponse.data) {
      userResponse.data.authorized = true
      userResponse.data.loading = false
      yield put({
        type: 'user/SET_STATE',
        payload: userResponse.data,
      })
      if (
        userResponse.data.card === undefined ||
        (userResponse.data.card !== undefined && !userResponse.data.card)
      ) {
        response = yield call(getBillingData)
        if (
          response.error !== undefined &&
          response.error.code !== undefined &&
          isAuthErrorCode(response.error.code)
        ) {
          yield put({
            type: 'user/LOGOUT',
          })
        }
        yield put({
          type: 'apps/SET_STATE',
          payload: {
            loading: false,
          },
        })
      }
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      yield put({
        type: 'user/LOGOUT',
      })
      yield history.push('/login')
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    yield history.push('/login')
  }
  return response
}

export function* CHECK_CARD_STATUS() {
  let userResponse = []

  if (localStorage.getItem('ccBearerToken')) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
      },
    })
    const loginData = { data: localStorage.getItem('meInfo') }
    const loginId = loginData.data.id
    userResponse = yield call(currentAccount, loginId)
    if (userResponse && userResponse.data) {
      userResponse.data.authorized = true
      userResponse.data.loading = false
      yield put({
        type: 'user/SET_STATE',
        payload: userResponse.data,
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      yield put({
        type: 'user/LOGOUT',
      })
      yield history.push('/login')
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    yield history.push('/login')
  }
  return userResponse
}
/*  BETA_CUSTOMER_CHECK */

export function* BETA_CUSTOMER_CHECK() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const currentUserMeta = reduxStore.getState().user.meta
  if (currentUserMeta.betaCustomer) {
    yield history.push('/apps')
  }
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

/*  BETA_CUSTOMER_CHECK */

export function* AUTHENTICATE_IF_USER_ALREADY_IN_SESSION() {
  if (localStorage.getItem('ccBearerToken')) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: true,
      },
    })

    if (
      reduxStore.getState().router &&
      reduxStore.getState().router.location !== undefined &&
      (reduxStore.getState().router.location.pathname === '/login' ||
        reduxStore.getState().router.location.pathname === '/verify-account' ||
        reduxStore.getState().router.location.pathname === '/signup' ||
        reduxStore.getState().router.location.pathname === '/sso-complete' ||
        reduxStore.getState().router.location.pathname === '/register' ||
        reduxStore.getState().router.location.pathname === '/forgot-password' ||
        reduxStore.getState().router.location.pathname === '/reset-password-email-sent' ||
        reduxStore.getState().router.location.pathname === '/verify/email/:id/:email' ||
        reduxStore.getState().router.location.pathname === '/verification-email-sent')
    ) {
      yield history.push('/apps')
    }
  }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
  return true
}

export function* UPDATE_CUSTOMER_CHOICE_OF_APPS_LAYOUT({ payload }) {
  const currentUserMeta = reduxStore.getState().user.meta
  const formValues = {
    meta: _.merge(currentUserMeta, {
      appsLayoutChoice: payload.appsLayoutChoice,
    }),
  }

  const success = yield call(updateProfile, formValues)

  return success
}

export function* UIKITS_V4_POPUP() {
  const currentUserMeta = reduxStore.getState().user.meta
  const formValues = {
    meta: _.merge(currentUserMeta, {
      newUIKitsPopup: true,
    }),
  }

  const success = yield call(updateProfile, formValues)
  if (success && success.data !== undefined) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
      data: success.data,
    })
  }
  return success
}

export function* REGISTER_EMAIL({ payload }) {
  const { email, resendEmail } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const formValues = {
    email: _.toLower(email).trim(),
  }
  if (resendEmail) {
    const { signupEmail } = reduxStore.getState().user
    if (signupEmail !== '') formValues.email = signupEmail
  }

  const success = yield call(registerEmail, formValues)
  if (success && success.data) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        signupEmail: formValues.email,
        loading: false,
      },
    })
    if (resendEmail) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: 'Verification email resent' },
      })
    } else {
      yield history.push(`/verification-email-sent?email=${formValues.email}`)
    }
  } else if (success && success.error) {
    if (success.errCode && success.errCode === 'ERR_EMAIL_ALREADY_EXISTS') {
      yield history.push('/login')
    }
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'info', message: success.errDescription },
    })
  }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
  return success
}

export function* GET_CUSTOMER_CONTEXT() {
  const params = reduxStore.getState().router.location.pathname.split('/verify/email/')[1]
  const verificationCode = params.split('/')[0]
  const email = atob(params.split('/')[1])
  const success = yield call(getCustomerContext, {
    verificationCode,
    email,
  })
  if (success && success.data !== undefined) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        customerContext: success.data,
      },
    })
  }
  return success
}

export function* UPDATE_CUSTOMER_ON_DISPLAYING_KICKOFF_CALL_SCREEN() {
  const currentUserMeta = reduxStore.getState().user.meta

  const formValues = {
    meta: _.merge(currentUserMeta, {
      viewedKickoffCallCalendar: true,
    }),
  }

  const success = yield call(updateProfile, formValues)

  return success
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, withCallback(LOGIN)),
    takeEvery(actions.LOGIN_OTP, withCallback(LOGIN_OTP)),
    takeEvery(actions.LOGIN_TOKEN, LOGIN_TOKEN),
    takeEvery(actions.SIGN_UP, withCallback(SIGN_UP)),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    takeEvery(actions.REQUEST_RESET_PASSWORD_EMAIL, REQUEST_RESET_PASSWORD_EMAIL),
    takeEvery(actions.RESET_PASSWORD, RESET_PASSWORD),
    takeEvery(
      actions.TEAM_COLLABORATOR_ACCEPT_INVITE,
      withCallback(TEAM_COLLABORATOR_ACCEPT_INVITE),
    ),
    takeEvery(actions.GOOGLE_LOGIN, GOOGLE_LOGIN),
    takeEvery(actions.UPDATE_USER_PROFILE, withCallback(UPDATE_USER_PROFILE)),
    takeEvery(actions.CUSTOMER_SWITCHED_DASHBOARD, withCallback(CUSTOMER_SWITCHED_DASHBOARD)),
    takeEvery(actions.ONBOARDING_STEP2, withCallback(ONBOARDING_STEP2)),
    takeEvery(actions.GET_BILLING_DATA, withCallback(GET_BILLING_DATA)),
    takeEvery(actions.CHECK_CARD_STATUS_ACTION, withCallback(CHECK_CARD_STATUS_ACTION)),
    takeEvery(actions.CHECK_CARD_STATUS, withCallback(CHECK_CARD_STATUS)),
    takeEvery(actions.BETA_CUSTOMER_UPDATE, BETA_CUSTOMER_UPDATE),
    takeEvery(actions.UPDATE_2FA_ACCOUNT_STATUS, UPDATE_2FA_ACCOUNT_STATUS),
    takeEvery(actions.SHOW_USER_FEEBACK, SHOW_USER_FEEBACK),
    takeEvery(
      actions.AUTHENTICATE_IF_USER_ALREADY_IN_SESSION,
      withCallback(AUTHENTICATE_IF_USER_ALREADY_IN_SESSION),
    ),
    takeEvery(actions.UPDATE_CUSTOMER_CHOICE_OF_APPS_LAYOUT, UPDATE_CUSTOMER_CHOICE_OF_APPS_LAYOUT),
    takeEvery(actions.UIKITS_V4_POPUP, UIKITS_V4_POPUP),
    takeEvery(actions.REGISTER_EMAIL, withCallback(REGISTER_EMAIL)),
    takeEvery(actions.GET_CUSTOMER_CONTEXT, withCallback(GET_CUSTOMER_CONTEXT)),
    takeEvery(
      actions.UPDATE_CUSTOMER_ON_DISPLAYING_KICKOFF_CALL_SCREEN,
      UPDATE_CUSTOMER_ON_DISPLAYING_KICKOFF_CALL_SCREEN,
    ),
    LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
  ])
}
